import React from 'react';

function AIBorder({
  borderRadius = 7,
  borderWidth = 2,
  duration = 14,
  color = ['var(--primary-Color)', '#FE8FB5', '#FFBE7B'],
  className,
  children,
}) {
  return (
    <div
      style={{
        '--border-radius': `${borderRadius}px`,
        '--border-width': `${borderWidth}px`,
        '--duration': `${duration}s`,
        '--background-radial-gradient': `radial-gradient(transparent, transparent, ${
          color instanceof Array ? color.join(',') : color
        }, transparent, transparent)`,
      }}
      className={`relative flex size-fit items-center justify-center rounded-(--border-radius) ${className || ''}`}
    >
      <div className="pointer-events-none absolute inset-0 size-full rounded-(--border-radius) bg-(image:--background-radial-gradient) bg-size-[300%_300%] p-(--border-width) will-change-[background-position] ai-ring-mask animate-ai-shine"></div>
      {children}
    </div>
  );
}

export default AIBorder;
